// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__bAXGW","actions":"GroupTable_actions__s9CYP","deleteModalFooter":"GroupTable_deleteModalFooter__2xWLB"};